// extracted by mini-css-extract-plugin
module.exports = {"termsContent":"TermsAndConditions_termsContent__1_FoH","termsContainer":"TermsAndConditions_termsContainer__2fV8r"};